import { render, staticRenderFns } from "./customerCenter.vue?vue&type=template&id=7a7183e2&"
import script from "./customerCenter.vue?vue&type=script&lang=js&"
export * from "./customerCenter.vue?vue&type=script&lang=js&"
import style0 from "./customerCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports